export default {"src":"/_next/static/media/facebook.327232eb.svg","height":40,"width":40};